import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, throwError } from "rxjs";
import { catchError } from "rxjs/operators";

import { InvoiceService } from "src/app/_services/invoice.service";
import { Config } from "../../../_store/config";
import { StorageService } from "../storage.service";
import { User } from "./user.model";

@Injectable({
  providedIn: "root",
})
export class AuthService {
  currentUserSubject = new BehaviorSubject<User>(null);
  isUnboarded = false;
  // currentUserSubject: any;

  constructor(
    private http: HttpClient,
    private storageService: StorageService,
    private invoiceService: InvoiceService,
  ) {}

  isLoggedIn() {
    return !!localStorage.getItem("eippSession");
  }

  signIn(data: any) {
    return this.http.post(Config.urls.LOGIN, data).pipe(
      catchError((errorRes) => {
        return throwError(errorRes);
      }),
    );
  }

  fetchAnalytics(data: any) {
    return this.http.post(Config.urls.ANALYTICS, data);
  }

  fetchInvoice_Analytics(data: any) {
    return this.http.post(Config.urls.INVOICE_ANALYTICS, data);
  }

  fetchPo_Analytics(data: any) {
    return this.http.post(Config.urls.PO_ANALYTICS, data);
  }

  fetchPoAnalytics(data: any) {
    return this.http.post(Config.urls.ANALYTICSPO, data);
  }

  fetchInvoiceAnalytics(data: any) {
    return this.http.post(Config.urls.ANALYTICSINVOICE, data);
  }

  fetchExternalAnalytics(data: any) {
    return this.http.post(Config.urls.ANALYTICSEXTERNAL, data);
  }

  fetchVendorMasterData(data: any) {
    return this.http.post(Config.urls.VENDORMASTERDATA, data);
  }

  forgotPassword(data: any) {
    return this.http.post(Config.urls.FORGOTPASSWORD, data);
  }

  resetPassword(data: any) {
    return this.http.post(Config.urls.RESETPASSWORD, data);
  }

  impersonate(data: any) {
    return this.http.post(Config.urls.IMPERSONATE, data);
  }

  forceChangePassword(data: any) {
    return this.http.post(Config.urls.FORCECHANGEPASSWORD, data);
  }

  changePassword(data: any) {
    return this.http.post(Config.urls.CHANGEPASSWORD, data);
  }

  setOnboardingStatus(data: any) {
    this.isUnboarded = data;
  }

  getOnboardingStatus() {
    return this.isUnboarded;
  }

  autoLogout(expirationDate: number) {
    setTimeout(() => {
      this.logOut(localStorage.getItem("eippSession"));
    }, expirationDate);
  }

  logOut(data: any) {
    sessionStorage.removeItem("onboardToken");
    return this.http.post(Config.urls.LOGOUT, data);
  }

  signUp() {}

  setCurrentUser(userData: any) {
    this.currentUserSubject.next(userData);
    this.storageService.add("currentUser", JSON.stringify(userData));
    this.invoiceService.fetchAllConfig({});
  }

  getCurrentUser() {
    const currentUser = this.storageService.get("currentUser");
    console.log(currentUser, "currentUser");
    if (currentUser) {
      this.currentUserSubject.next(JSON.parse(currentUser));
    }
    console.log(this.currentUserSubject.value, "this.currentUserSubject.value");

    return this.currentUserSubject.value;
  }

  /** Seller code from login (session user), with localStorage fallback from sign-in. */
  getSellerCode(): string {
    const user = this.getCurrentUser();
    return user?.sellerCode ?? localStorage.getItem("sellerCode") ?? "";
  }
}
